import { T } from "../lib/theme";

const Toggle = ({ value, onChange }) => (
  <div
    onClick={() => onChange(!value)}
    style={{
      width: 44, height: 24, borderRadius: 12, cursor: "pointer",
      background: value ? T.emerald : "rgba(255,255,255,0.1)",
      position: "relative", transition: "background 0.25s",
      flexShrink: 0, animation: value ? "pulseGlow 2s infinite" : "none",
    }}
  >
    <div style={{
      position: "absolute", top: 3, left: value ? 23 : 3,
      width: 18, height: 18, borderRadius: "50%",
      background: "#fff", transition: "left 0.25s",
      boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
    }} />
  </div>
);

export default Toggle;